import { CdkAccordionItem } from '@angular/cdk/accordion';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

import { I18nModule } from '@spartacus/core';

import { FADE_IN_CONTENT_BY_HEIGHT_OPACITY } from '@app/core/constants/animations.constant';
import { FACET_SPECIALS } from '@app/core/types/facet-spetials.type';
import { FacetCategory } from '@app-modules/product/product-facet-navigation/types';

import { DpFacetComponent, DpFacetRangeComponent, DpFacetSearchComponent } from '../facet';

@Component({
    selector: 'dp-facet-list',
    templateUrl: './facet-list.component.html',
    styleUrls: ['./facet-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DpFacetComponent,
        MatIcon,
        FormsModule,
        I18nModule,
        ReactiveFormsModule,
        DpFacetSearchComponent,
        DpFacetRangeComponent,
        CdkAccordionItem,
        NgClass
    ],
    animations: [FADE_IN_CONTENT_BY_HEIGHT_OPACITY]
})
export class DpFacetListComponent {
  facetCategory = input.required<FacetCategory>();
  selected = input.required<boolean>();
  readonly specialFacetTypes = FACET_SPECIALS;
}
